import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_STATE = {};

const scheduleSlice = createSlice({
    name: "schedule",
    initialState: INITIAL_STATE,
    reducers: {
        receive_rightRail: (state, action) => {
            if (action.payload.type) {
                // Update the current type's schedule in the state (e.g. radio type schedule, or sports)
                const updatedState = {
                    [action.payload.type]: action.payload,
                };
                return {
                    ...state,
                    ...updatedState,
                };
            }
        },
        loading: (state, action) => {
            const { loading } = action.payload;
            return {
                ...state,
                sportsSchedule: {
                    ...state?.sportsSchedule,
                    loading,
                },
            };
        },
        receive_main: (state, action) => {
            const { key, sportsSchedule, filteredScheduleList, caption } =
                action.payload;

            return {
                ...state,
                sportsSchedule,
                [key]: {
                    ...state[key],
                    filteredScheduleList,
                    caption,
                },
            };
        },
        update_filter: (state, action) => {
            const {
                key,
                filter,
                zone,
                filteredScheduleList,
                caption,
                dropDownList,
            } = action.payload;

            return {
                ...state,
                [key]: {
                    ...state[key],
                    dropDownList,
                    filter,
                    zone,
                    filteredScheduleList,
                    caption,
                },
            };
        },
        update_drop_down_list: (state, action) => {
            const { key, dropDownList } = action.payload;
            return {
                ...state,
                [key]: {
                    ...state[key],
                    dropDownList,
                },
            };
        },
        update_filter_bar: (state, action) => {
            const { filterBar, key, filteredScheduleList, caption } =
                action.payload;
            return {
                ...state,
                [key]: {
                    ...state[key],
                    filterBar,
                    filteredScheduleList,
                    caption,
                },
            };
        },
    },
});

export const {
    receive_rightRail: receive_rightRail_schedule,
    loading: loading_sports_schedule,
    receive_main: receive_main_sports_schedule,
    update_filter: update_sports_filter,
    update_drop_down_list: update_sports_drop_down_list,
    update_filter_bar: update_sports_filter_bar,
} = scheduleSlice.actions;

export default scheduleSlice.reducer;
